/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInterestAccrualRange} from '../api'

 export const useQueryGetInterestAccrualRange = createReactQueryHook('getInterestAccrualRange', getInterestAccrualRange)
